import http from "../http/http-config";
import { CapitalRange } from "../models/capitalRange";

export default new class capitalRangeService {
    getCapitalRange(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType): Promise<CapitalRange[]> {
        return http.get<CapitalRange[]>("CapitalRange", {
            params: {                
                onDate,
                productId,
                securityGroup,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}